import colors from './colors';
import dimensions from './dimensions';
import typography from './typography';
import { dialpadstyle } from './dialpadstyle';

export { colors, dimensions, typography, dialpadstyle };



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/styles/index.js